import React, { useEffect, useState } from "react";
import axios from "../../../../../../Services/axiosCommon";
import { Link, useLocation, useParams } from "react-router-dom";
import Pagination from "../../../../../../Components/Utils/Pagenation";
import { Button, Modal,  Select } from "antd";
import { useFormik } from 'formik';
import * as yup from "yup";
import { useNumber } from "../../../../../../Context/ProjectIdContext";
import ProgressLayout from "../ProgressLayout";
import ViewMore from "./ViewMore";
import TableData from "./TableData";
import { GetAccess } from "../../../../../../Components/Utils/roles";
import FormikSelectTwo from "../../../../../../Components/Utils/Select";
import NuDate from "../../../../../../Components/Utils/NuDate";
import { EditButton, LongButton } from "../../../../../../Components/Utils/Buttons";



function Installation() {
  const { officeId } = useParams();
  const { projectId } = useParams();
  const location = useLocation();
  const projectTask = location?.state?.projectTask || "";
  const { number, updateNumber } = useNumber();
  const [percentOpen,setPercentOpen] = useState(false);
  const [open, setOpen] = useState(false);
  const [filterOpen, setFilterOpen] = useState(false);
  const [pageIndex, setPageIndex] = useState(1);
  const [dataCount, setDataCount] = useState(20);
  const [totalTasks, setTotalProject] = useState(0);
  const [searchQuery, setSearchQuery] = useState("");
  const [projectList, setProjectList] = useState([]);
  const [data, setData] = useState([]);
  const [status, setStatus] = useState([])
  const [priority, setPriority] = useState([]);
  const [firstProject, setFirstProject] = useState("");
  const [isFilter,setIsFilter]= useState(false);
  const [notFirst,setNotFirst]=useState(false)
  const [filterData,setFilterData]= useState({
    SDF:"",
    EDT:"",
    status: "",
    priority: "",
  });
  const [afterFilter,setAfterFilter]= useState({})
  const [screenSize, setScreenSize] = useState({
    width: window.innerWidth,
  });

const currentPage= location.state?.currentPage

    const [page, setPage] = useState(currentPage||1)
       const [pageCount, setPageCount] = useState(localStorage.getItem("perPageView")||20)

  const [params, setParams] = useState({
          page: page,
          per_page: pageCount,
          search:searchQuery||"",
      
          unit:"",
           });


  useEffect(() => {
    const handleResize = () => {
      setScreenSize({
        width: window.innerWidth,
      });
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  async function getProject() {
    await axios
      .get(`/Team/getUserProjectId`)
      .then(async (res) => {
        if(number!=0){
          setFirstProject(number)
        }else if (projectTask) {
          setFirstProject(projectTask);
        } else {
          res?.data?.data[0] && setFirstProject(res?.data?.data[0]?.ProjectId)
          updateNumber(res?.data?.data[0]?.ProjectId)

        }
        let list = res?.data?.data || [];
        let finalData = [];
        (await res?.data?.data) &&
          list.map((item, idx) => {
            finalData.push({
              value: item.ProjectId,
              label: item.ProjectName,
            });
          });
        setProjectList(finalData);

        // await res?.data?.Project && setTotalProject(res?.data?.totalProject);
        // console.log('====',res?.data?.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }

  const getStatus = () =>{
    axios.get(`/Metadata/taskstatus`).then(res=>{
        let data = res.data?.data?.keyValues;
        let tempData = [];
        data.forEach((item) => {
          let tempObject = { value: item, label: item };
          tempData.push(tempObject);
        });
        res.data?.data?.keyValues && setStatus(tempData);
    }).catch(error=>{
        console.log("dddd");
    })
}

const getPriority = () =>{
  axios.get(`/Metadata/taskpriority`).then(res=>{
      let data = res.data?.data?.keyValues;
      let tempData = [];
      data.forEach((item) => {
        let tempObject = { value: item, label: item };
        tempData.push(tempObject);
      });
      res.data?.data?.keyValues && setPriority(tempData);
  }).catch(error=>{
      console.log("dddd");
  })
}

  useEffect(() => {
    getStatus()
    getProject();
    getPriority();
  }, []);

  function SearchData(e) {
    setNotFirst(true)
    e.preventDefault();
    if (searchQuery != "") {
      axios
        .get(`/mytask/byUser/members_tasks/${firstProject}?page=${pageIndex}&per_page=${dataCount}`,{params:{search:`${searchQuery}`}})
        .then((res) => {
          setData(res.data?.data);
        setTotalProject(res.data?.total_records)

        })
        .catch((err) => console.log(err));
    } else {
      getTask(firstProject);
    }
  }

  function SearchPageDate(){
    axios
    .get(`/mytask/byUser/members_tasks/${firstProject}?page=${pageIndex}&per_page=${dataCount}`,{params:{search:`${searchQuery}`}})
    .then((res) => {
      setData(res.data?.data?.installation);
      setTotalProject(res.data?.total_records)

    }).catch((err) => console.log(err))
  }

  function handleProjectChange(e) {
    setFirstProject(e);
    updateNumber(e)
  }

  function getTask() {
    axios
      .get(`/installation/?page=${pageIndex}&per_page=${dataCount}`)
      .then((res) => {
        setData(res.data?.data);
        setTotalProject(res.data?.total_records)

      })
      .catch((error) => {
        console.log(error);
      });
  }

  useEffect(() => {
    if (searchQuery == "") {
      getTask();
    }
  }, [searchQuery]);



  const userAccess = JSON.parse(localStorage.getItem("userAccess"));
  let MyTaskCreate = userAccess
    ? userAccess.some(
        (permission) => permission.permissionName == "MyTask_create"
      )
    : false;

  useEffect(() => {
    // console.log("jj",projectNum);
    if (projectTask) {
      setFirstProject(projectTask);
      // console.log("gf", firstProject);
    }
  }, [projectTask]);


  const formik = useFormik({
    enableReinitialize: true,
    initialValues: filterData,
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema: yup.object({
      mobileNo: yup
        .string()
        // .required("Mobile Number is required")
        .matches(
          /^((\\[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/,
          "Enter Valid Mobile Number"
        )
        .min(10, "Invalid Mobile Number")
        .max(10, "Invalid Mobile Number"),
      // email: yup.string().required("Email is required"),
    }),
    onSubmit: async (value, { resetForm }) => {
      setAfterFilter(value)
      setIsFilter(true)
      axios
      .get(`/mytask/byUser/members_tasks/${firstProject}?page=${pageIndex}&per_page=${dataCount}`,{params:{status:`${value.status}`,SDF:`${value.SDF}`,EDT:`${value.EDT}`,priority:`${value.priority}`}})
      .then((res) => {
        setFilterOpen(false)
        setData(res.data?.data);
        setTotalProject(res.data?.total_records)

      })
      .catch((error) => {
        console.log(error);
      });
    },
  });
  const [flatSelectedItemIds, setFlatSelectedItemIds] = useState([]);
  const [selectedTitles, setSelectedTitles] = useState([]);
  const [selectedExpandedItems, setSelectedExpandedItems] = useState([]);
  const [multiEditOpen, setMultiEditOpen] = useState(false);
  
  
  const handleMainCheckboxChange = (titleId, items) => {
    setSelectedTitles((prevSelectedTitles) =>
      prevSelectedTitles.includes(titleId)
        ? prevSelectedTitles.filter((id) => id !== titleId)
        : [...prevSelectedTitles, titleId]
    );
  
    setSelectedExpandedItems((prevSelectedExpandedItems) => ({
      ...prevSelectedExpandedItems,
      [titleId]: selectedTitles.includes(titleId)
        ? [] // Clear items if main checkbox is deselected
        : items.map(item => item.id), // Select all items if main checkbox is selected
    }));
  };
  
  const handleExpandedCheckboxChange = (titleId, itemId) => {
    setSelectedExpandedItems((prevSelectedExpandedItems) => ({
      ...prevSelectedExpandedItems,
      [titleId]: prevSelectedExpandedItems[titleId]?.includes(itemId)
        ? prevSelectedExpandedItems[titleId].filter((id) => id !== itemId)
        : [...(prevSelectedExpandedItems[titleId] || []), itemId],
    }));
  };
  useEffect(() => {
    const allSelectedIds = Object.values(selectedExpandedItems).flat();
    setFlatSelectedItemIds(allSelectedIds);
  }, [selectedExpandedItems]);

  function FilterPage(){
    axios
      .get(`/mytask/byUser/members_tasks/${firstProject}?page=${pageIndex}&per_page=${dataCount}`,{params:{status:`${afterFilter.status}`,SDF:`${afterFilter.SDF}`,SDT:`${afterFilter.SDT}`,EDF:`${afterFilter.EDF}`,EDT:`${afterFilter.EDT}`,priority:`${afterFilter.priority}`}})
      .then((res) => {
        setData(res.data?.data);
        setTotalProject(res.data?.total_records)

      }).catch(err=>console.log(err))
  }


  function ClearFilter(){
    formik.resetForm({})
    getTask(firstProject);
    setIsFilter(false)
  }
   const [valueOfSearch,setValuesofSearch] = useState("")
       function searchFunction(e) {
     
         
         setValuesofSearch(e?.target?.value)
         setParams({ ...params, search: e?.target?.value, page:1 });
         setPage(1)
       }

  useEffect(()=>{
   if(isFilter){
    FilterPage();
   }else if(searchQuery !=""){
      SearchPageDate();
    }else{
    getTask()
    }
  },[pageIndex,dataCount])

  console.log("zzzz",firstProject);

  return (

      <>
      <ProgressLayout
            setOpen={setOpen}
            setSearchQuery={setSearchQuery}
            SearchData={SearchData}
            isFilter={isFilter}
            setFilterOpen={setFilterOpen}
            ClearFilter={ClearFilter}
            CreateAccess={false}
            ImportAccess={false}
            officeId={officeId}
            projectId={projectId}
            neededSearch={true}
    searchQuery={searchQuery} 
    searchFun={searchFunction}
    searchValue={valueOfSearch}

      >
          <div className=" w-full h-[calc(100vh-195px)] p-3 overflow-y-auto">

            {/* {flatSelectedItemIds.length > 0 ? 
                      <div className="w-full flex justify-end gap-2 py-2">
                      <EditButton height="5" value="Multi Edit" handleClick={() => { setMultiEditOpen(true) }}/>
                      <button
                        type='button'
                        className="px-2 h-5 cursor-pointer text-xs text-red-500 bg-white rounded-md flex items-center"
                        style={{ border: "1px solid red" }}
                        onClick={() => {handleDelete(flatSelectedItemIds)}}
                      >
                        Multi Delete
                      </button>
                    </div>
                      :
                      null
                      } */}
            <table
              className="table-auto static top-0 w-full"
              style={{ border: "none", borderCollapse: "collapse" }}
            >
              <thead className=" w-full bg-white p-3 mt-4">
                <tr className="text-xs border-b  font-medium  py-3">
                  {header.map((header, i) => (
                    <th
                      className={`py-3 ${header.width}  ${header?.isLeft?"text-left":"text-center"} font-medium text-xs 2xl:text-sm text-[#4F4768]`}
                      key={i}
                      style={{ border: "none", borderCollapse: "collapse" }}
                    >
                      {header.headone}
                    </th>
                  ))}
                </tr>
              </thead> 
              <tbody className="">
                {data && data.map((item, i) => (
                  <TableData key={i} item={item} getTask={getTask} />
                ))}
              </tbody>
            </table>
          </div>
      
      <div className="h-7 my-[2px] px-3">
        <Pagination
          total={totalTasks}
          pageIndex={pageIndex}
          setPageIndex={setPageIndex}
          dataCount={dataCount}
          setDataCount={setDataCount}
        />
      </div>
      </ProgressLayout>

      <Modal
            open={filterOpen}
            title={"Filter Installation"}
            width={"50%"}
            className="my-modal"
            centered
            onCancel={() => setFilterOpen(false)}
            footer={[]}
          >
            <form onSubmit={formik.handleSubmit}>
              <div className=" w-full flex flex-wrap">
              <FormikSelectTwo
              label="Status"
              Options={status}
              formik={formik}
              placeholder="Choose"
              name="status"
              width="w-full"
              // cceptType="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            />
              <FormikSelectTwo
              label="Priority"
              Options={priority}
              formik={formik}
              placeholder="Choose"
              name="Priority"
              width=" w-full"
              // cceptType="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            />
                <LongButton value='Filter'/>
              </div>
            </form>
          </Modal>

      {/* <Modal
        open={filterOpen}
        title={"Filter My Installation"}
        width={"50%"}
        className="my-modal"
        centered
        onCancel={()=>setFilterOpen(false)}
        footer={[]}
      >
        <form onSubmit={formik.handleSubmit}>
          <div className=" w-full ">
          <FormikSelectTwo
              label="Status"
              Options={status}
              formik={formik}
              placeholder="Choose"
              name="status"
              width="w-full"
              // cceptType="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            />
              <FormikSelectTwo
              label="Priority"
              Options={priority}
              formik={formik}
              placeholder="Choose"
              name="Priority"
              width=" w-full"
              // cceptType="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            />
          {/* <NuDate
              label="Start Date"
              // options={status}
              formik={formik}
              placeholder="Choose"
              name="SDF"
              width=" w-full"
            />
            <NuDate
              label="End Date"
              // options={status}
              formik={formik}
              placeholder="Choose"
              name="EDT"
              width=" w-full"
            /> */}
            {/* <NuSelect
              label="Status"
              options={status}
              formik={formik}
              placeholder="Choose"
              name="filterStatus"
              width=" w-1/2"
              // cceptType="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            /> */}
                      {/* <LongButton value='Filter'/> */}
            
            {/* <Button
              htmlType="submit"
              size="large"
              className="w-11/12 bg-[#119DEE] text-white  mx-auto"
            >
              Filter 
            </Button> */}
          {/* </div>
        </form>
      </Modal> */}
      </>
  );
}

export default Installation;

const header = [
  // {
  //   headone: "ID",
  //   width: "w-[3%]",
  //   // isLeft: true,
  // },
  {
    headone: "Sl.No",
    width: "w-[5%]",
    isLeft: true,
  }, 
  {
    headone: "Description / Activity",
    width: "w-[20%]",
    isLeft: true,
  },
  // {
  //   headone: "Category",
  //   width: "w-[10%]",
  //   isLeft: true,
  // },
  // {
  //   headone: "Cost Per Hour",
  //   width: "w-[8%]",
  // },
  {
    headone: "Division",
    width: "w-[9%]",
    isLeft: true,

  },
  {
    headone: "Unit",
    width: "w-[9%]",
    isLeft: true,

  },
  {
    headone: "Qty",
    width: "w-[14%]",
    isLeft: true,

  },
  {
    headone: "Installed",
    width: "w-[9%]",
    isLeft: true,

  },
  {
    headone: "Today",
    width: "w-[14%]",
    isLeft: true,

  },
  // {
  //   headone: "Cummulative",
  //   width: "w-[10%]",
  //   isLeft: true,
  // },
  {
    headone: "Remaining",
    width: "w-[15%]",
    isLeft: true,
  },
  {
    headone: "Action",
    width: "w-[5%]",
  },
];
